export default __webpack_public_path__ + "static/media/RocketDAO-Congratulations_new.5f285bf2.svg";